<template>
  <div class="order-mode">
    <h3>{{ mode }}</h3>
    <span>
      id:
      <h3 class="cheque-id">{{ chequeId }}</h3>
    </span>
  </div>
</template>

<style scoped>
.order-mode {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 2.5vh 5.4vw 1.9vh;
}

.order-mode h3 {
  margin: 0;
  font-weight: 500;
  font-size: 3.3vh;
}

h3.cheque-id {
  font-size: 3.2vh;
  line-height: 2.431vw;
  display: inline;
}

.order-mode span {
  position: relative;
  right: 0;
  font-size: 1.8vh;
  line-height: 1.181vw;
}

@media screen and (min-width: 768px) {
  .order-mode {
    padding: 1.736vw 1.389vw 1.389vw;
  }
  .order-mode span {
    font-size: 1.042vw;
  }
  h3.cheque-id {
     font-size: 2.083vw;
    line-height: 2.431vw;
  }
  .order-mode h3 {
    font-size: 2.083vw;
    line-height: 2.431vw;
  }
}
</style>

<script>
//  preorder.local_id
export default {
  props: {
    mode: String,
    chequeId: String,
  },
};
</script>